import { memo, useRef, useState } from "react";
import {
  FormikAutocomplete,
  FormikTextField,
} from "@accessinformatica/formik-mui";
import FormikDateTimePicker from "../../../commons/formik/formikDateTimePicker";
import { StyledCommonForms } from "../../../styled/form";
import DireccionFpt from "../fpt/direccionFpt";
import {
  locationFromCoords,
  resolvePuntoMinDate,
  TIPOS_DIRECCION,
} from "./fptTrasladosUtils";

const sameLocation = (left, right) =>
  (left?.lat ?? null) === (right?.lat ?? null) &&
  (left?.lng ?? null) === (right?.lng ?? null);

const PuntoForm = ({
  index,
  values,
  setFieldValue,
  fields,
  disabled,
  addressLocked = false,
  idArt,
  fechaHoraTurno,
  prevFechaHora,
  showMap = true,
}) => {
  const namePrefix = `puntos.${index}`;
  const punto = values.puntos[index];
  const minFechaHora = resolvePuntoMinDate(fechaHoraTurno, prevFechaHora, index);
  const [direccionesHabituales, setDireccionesHabituales] = useState([
    ...fields.direccionesHabituales.options,
  ]);
  const location =
    punto.location || locationFromCoords(punto.latitud, punto.longitud);
  const locationRef = useRef(location);
  locationRef.current = location;
  const addressDisabled = disabled || addressLocked;

  const handleLocationChange = (nextLocation) => {
    if (sameLocation(locationRef.current, nextLocation)) return;
    setFieldValue(`${namePrefix}.location`, nextLocation, false);
    setFieldValue(`${namePrefix}.latitud`, nextLocation?.lat ?? "", false);
    setFieldValue(`${namePrefix}.longitud`, nextLocation?.lng ?? "", false);
  };

  const tipoDireccion = (
    <FormikAutocomplete
      disabled={addressDisabled}
      label="Tipo de dirección *"
      name={`${namePrefix}.tipoDireccion`}
      options={TIPOS_DIRECCION}
      sx={StyledCommonForms.input}
      variant="outlined"
    />
  );

  return (
    <>
      {index === 0 ? (
        <StyledCommonForms.RowContainer>{tipoDireccion}</StyledCommonForms.RowContainer>
      ) : (
        <StyledCommonForms.RowContainer>
          <StyledCommonForms.LeftColumnContainer>
            {tipoDireccion}
          </StyledCommonForms.LeftColumnContainer>
          <StyledCommonForms.RightColumnContainer>
            <FormikDateTimePicker
              autoComplete="off"
              disabled={disabled}
              label="Fecha y hora del tramo *"
              variant="outlined"
              minDate={minFechaHora}
              name={`${namePrefix}.fechaHora`}
              sx={StyledCommonForms.input}
            />
          </StyledCommonForms.RightColumnContainer>
        </StyledCommonForms.RowContainer>
      )}

      <DireccionFpt
        direccionesHabituales={direccionesHabituales}
        disabled={addressDisabled}
        fields={fields}
        idArt={idArt}
        initialValues={values}
        isDesde={index === 0}
        location={location}
        localidadesKey={punto.id}
        namePrefix={namePrefix}
        onLocationChange={handleLocationChange}
        setDireccionesHabitualesOtro={setDireccionesHabituales}
        setFieldValue={setFieldValue}
        showMap={showMap}
        showSearch={!punto.esRetorno}
        title=""
        values={values}
      />

      <StyledCommonForms.RowContainer>
        <FormikTextField
          disabled
          label="Distancia tramo"
          name={`${namePrefix}.distanciaLabel`}
          sx={StyledCommonForms.input}
          variant="outlined"
        />
      </StyledCommonForms.RowContainer>
    </>
  );
};

export default memo(PuntoForm, (prev, next) => {
  if (
    prev.index !== next.index ||
    prev.disabled !== next.disabled ||
    prev.showMap !== next.showMap ||
    prev.addressLocked !== next.addressLocked ||
    prev.idArt !== next.idArt ||
    prev.fechaHoraTurno !== next.fechaHoraTurno ||
    prev.prevFechaHora !== next.prevFechaHora ||
    prev.fields !== next.fields
  ) {
    return false;
  }
  return prev.values.puntos[prev.index] === next.values.puntos[next.index];
});
